import { getUrlParam } from 'common/util/location';
import { useEffect, useRef, useState } from 'react';
import * as K from 'common/constants';
import Page from 'components/common/Page/Page';
import PageHeader from 'components/common/PageHeader/PageHeader';
import { SSO_INVITE_TOKEN_ERRORS } from './constants';

function SSOInvite(): JSX.Element {
  const formEl = useRef<HTMLFormElement>(null);
  const [error, setError] = useState<Error>();
  const errorParamValue = getUrlParam(window.location.search, K.URL_PARAM.ERR);
  const emailParamValue = getUrlParam(window.location.search, K.URL_PARAM.USER_EMAIL);
  const inviteToken = getUrlParam(window.location.search, K.URL_PARAM.INVITE_TOKEN);
  /*
   * SSO Invite page is invoked from email. When user comes to this page, if invite token is present,
   * a POST form is submitted to /v2/sso/invite API with invite token. The API, if everything looks good,
   * will redirect user to the SSO IdP page. If there is any server side error, user is redirected back to this page to show the error message
   */
  useEffect(() => {
    if (!errorParamValue && inviteToken && formEl && formEl.current) {
      formEl.current.submit();
    } else {
      let errMessage = 'Something went wrong. Unexpected error occurred.';
      if (!inviteToken) {
        errMessage = 'The invite token is missing';
      }
      if (errorParamValue === SSO_INVITE_TOKEN_ERRORS.badIdPConfiguration) {
        errMessage =
          'There was a problem parsing the identity provider details for your organization. Please contact Support.';
      } else if (errorParamValue === SSO_INVITE_TOKEN_ERRORS.badInvitationUrl) {
        errMessage = 'The invite token could not be parsed.';
      } else if (errorParamValue === SSO_INVITE_TOKEN_ERRORS.incorrectInvitee) {
        errMessage = 'This invitation was issued to a different account.';
      } else if (errorParamValue === SSO_INVITE_TOKEN_ERRORS.invalidInvitee) {
        errMessage = `There is no ${K.PRODUCT_NAME} account associated with the email address: ${emailParamValue}. Ask an administrator to send you another invitation to join.`;
      } else if (errorParamValue === SSO_INVITE_TOKEN_ERRORS.invalidSsoInvitee) {
        errMessage = `This invitation was issued for use with SSO, but your email address ${emailParamValue} is not currently configured for SSO. Please ask an administrator to send you another invitation to join this team.`;
      } else if (errorParamValue === SSO_INVITE_TOKEN_ERRORS.unknown) {
        errMessage = 'Something went wrong. Unexpected error occurred.';
      }
      const errorFromParam: Error = { message: errMessage, name: errorParamValue };
      setError(errorFromParam);
    }
  }, []);

  if (error) {
    return (
      <Page docTitle="Link Account" pageModifier="AcceptLinkInvite__Title">
        <PageHeader title="Unable to link your account" />
        <div className="AcceptLinkInvite__Container">
          <h4 className="AcceptLinkInvite__InviteInfo AcceptLinkInvite__InviteInfo--Bold">{error.message}</h4>
        </div>
      </Page>
    );
  }
  return (
    <>
      <form ref={formEl} method="POST" action="/v2/sso/invite">
        <input type="hidden" name="inviteToken" value={inviteToken} />
      </form>
    </>
  );
}

export default SSOInvite;
